module.exports = __webpack_public_path__ + "assets/ic_play.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/ic_play.svg
// module id = 449
// module chunks = 19